<template>
  <CrudList
    title="Orders"
    storeName="Keep_track_users"
    parentStoreName="Insights"
    :sortable="true"
    :show_filters="false"
    :canSearch="true"
    :canAdd="false"
    :canEdit="false"
    :canDelete="false"
    :canExport="true"
  >
    <template v-slot:date_sales="{ }">
        <v-row class="justify-end">
          <v-col class="col-12 col-md-6">
              <v-select 
                clearable
                v-model="user_id"
                :items="users_discount"
                item-text="fullname"
                item-value="id"
                label="User"
                hide-details

              ></v-select>
          </v-col>
          <v-col class="col-12 col-md-4">
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dates"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  ref="inputRef"
                  clearable
                  v-model="dateRangeText"
                  label=""
                  prepend-icon="fas fa-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="onClearDates"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" range no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    changeData(dates);
                    $refs.menu.save(dates);
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="col-2">

          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-12 col-sm-6 pt-8">
              <v-btn @click="applySearch">
                Search
                <v-icon class="ml-2">fas fa-search</v-icon>
              </v-btn>
            </v-col>
          <v-col class="col-12 col-sm-4 vertical-middle">
            <v-btn
                depressed
                color="primary"
                class="mt-5"
                v-on:click="exportBtn"
                id="keep-track-export"
            >
              <v-icon left>fas fa-download</v-icon>
              Export as
            </v-btn>

          </v-col>
        </v-row>
    </template>
    <template v-slot:user_id="{ item }">
      
      <v-row align="center" justify="center">
        <v-col cols="12">
           {{item.client? item.client.fullname:''}}
         </v-col>
      </v-row>
    </template>
    <template v-slot:discount="{item}">
      <v-row align="center" justify="center">
        <v-col cols="12">
          {{converfloat(item.discount)}}
        </v-col>
      </v-row>
    </template>
    <template v-slot:store_id="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          {{item.store?item.store.name:''}}
        </v-col>
      </v-row>
    </template>
    <template v-slot:company_id="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          {{item.store && item.store.region_id && item.store.region_id.company_id?item.store.region_id.company_id.name:''}}
        </v-col>
      </v-row>
    </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import { mapActions, mapState } from "vuex";
import { config } from "@/config/constants.js"; 

export default {
  components: { CrudList },
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    ...mapState({
      users_discount: state => state.Keep_track_users.users_discount
    }),
  },
  data() {
    return {
      token: this.$store.state["Authenticate"].token,
      dates: [
        
      ],
      filter_dates:{},
      menu: false,
      user_id: '',
      filter: {},
    }
  },
  async created() {
    const self = this;
    await self.$store.dispatch("Keep_track_users/get_users_discount");
  },
  methods: {
    converfloat(x) {
      if (x)
      return Number.parseFloat(x).toFixed(2);
    },
    async changeData(dates) {
      const self = this;
      if (dates[0] && dates[1] && dates[0] <= dates[1]) {
        self.filter_dates.start_date = dates[0];
        self.filter_dates.end_date = dates[1];
      }
      if (dates[1] && dates[0] && dates[1] <= dates[0]) {
        self.filter_dates.start_date = dates[1];
        self.filter_dates.end_date = dates[0];
      }
    },
    exportBtn(){
      const self = this;
      self.get_filters()
      const queryString = Object.keys(self.filter)
        .map(key => key + "=" + self.filter[key])
        .join("&");
      window.location.href =
        config.api_url +
        'Keep_track_users'.toLowerCase() +
        "?format=csv&" +
        queryString +
        "&authorization=" +
        this.token;

    },
    async applySearch(){
      const self = this;
      self.get_filters()
      await self.$store.dispatch("Keep_track_users/getListAll",self.filter);
    },
    get_filters(){
      const self = this;
      self.filter = {}
      if(self.user_id != ''){
        self.filter.user_id = self.user_id;
      }
      if(self.filter_dates.start_date && self.filter_dates.start_date){
        self.filter.start_date = self.filter_dates.start_date;
        self.filter.end_date = self.filter_dates.end_date;
      }
    },
    onClearDates(){
      this.dates = [];
      this.filter_dates={};
    }
  }
};
</script>
